'use strict';

export class Contact {
  constructor() {
    //
  }
}
